/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { StepProps } from './AddEditDocument';

export const DocumentForm = ({ touched, errors, values, setFieldValue, readOnly }: StepProps) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.currentTarget.files?.[0] || null;
    setFieldValue?.('file', file);
  };
  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Document Details" showRequiredLegend={!readOnly} />
        </Col>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="title"
          >
            <FormLabel required>Title</FormLabel>
            <Field
              name="title"
              as={Form.Control}
              isInvalid={touched.title && !!errors.title}
              aria-required
            />
            <ErrorMessage name="title">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="total"
          >
            <FormLabel>Description</FormLabel>
            <Field
              name="description"
              type="textarea"
              as={Form.Control}
              isInvalid={touched.description && !!errors.description}
            />
            <ErrorMessage name="description">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="total"
          >
            <FormLabel>File</FormLabel>
            <Field
              name="file_name"
              type="file"
              as={Form.Control}
              onChange={handleFileChange}
              isInvalid={touched.file && !!errors.file}
            />
            <ErrorMessage name="document">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
